import { useContext } from 'react'
import { enqueueSnackbar } from 'notistack'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'

import { AppContext } from '/providers/app-context'
import { syncPasses } from '/providers/passes-api'

const SynchroniseDialog = ({ open, setOpen, template }) => {
  
  const { apiSource, apiKeys, refreshTemplates, processing, setProcessing } = useContext(AppContext)

  if (!template) return null
  
  const apple = template.live_passes_not_synced_apple
  const google = template.live_passes_not_synced_google
  const total = apple + google
  
  const doSyncPasses = async () => {
    close()
    setProcessing(true)
    enqueueSnackbar({ message: 'Synchronising passes', variant: 'light' })
    const result = await syncPasses({ apiSource, apiKeys, templateId:template.id })

    if (result.error) {
      enqueueSnackbar({ message: result.error.message ?? "Error synchronising passes", variant: 'error' })
    } else {
      enqueueSnackbar({ message: 'Synchronisation complete', variant: 'success' })
    }

    setProcessing(false)
    await refreshTemplates(template.id)
  }

  const close = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Syncronise Passes : {template.name}
      </DialogTitle>

      <DialogContent>
        <p className='mb-5'>Synchronising passes will push template changes to already issued passes.
          Without synchronisation, existing Google Android passes will only reflect
          Class changes. Object changes will only be applied to new passes.</p>

        <p className='mb-5'>With Apple passes, no changes are applied to existing passes.</p>

        {total > 0 &&
          <p className='mb-5'>
            Apple passes to sync : {apple}<br />
            Google Android passes to sync : {google}<br />
          </p>
        }

        {total === 0 &&
          <p className='mb-5'>Nothing to synchronise. All passes are up-to-date.</p>
        }

      </DialogContent>
      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={doSyncPasses} autoFocus disabled={processing || total === 0}><SyncOutlinedIcon className="mr-5" />Synchronise Passes</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default SynchroniseDialog